import { post } from "./http";

const lngApi = {
  // 首页-是否提报
  hasSubmitPlan: (params) => {
    return post("/console/lng/hasSubmitPlan", params);
  },
  // 首页-今日累计量
  consoleDay: (params) => {
    return post("/console/lng/consoleDay", params);
  },
  //首页-查看历史记录
  listDayPage: (params) => {
    return post("/app/lng/listDayPage", params);
  },
  //LNG-买家销售公司列表
  listSeller: (params) => {
    return post("/common/lng/listSeller", params);
  },
  listDayPlan: (params) => {
    return post("/app/lng/dayPlan", params);
  }, //LNG-日计划列表
  viewDayPlanList: (params) => {
    return post("/app/lng/viewDayPlanList", params);
  }, //LNG-日计划查看列表
  applyChangeDayPlanList: (params) => {
    return post("/app/lng/applyChangeDayPlanList", params);
  }, //LNG-日计划变更申请列表
  viewChangeDayPlanList: (params) => {
    return post("/app/lng/viewChangeDayPlanList", params);
  }, //LNG-日计划变更查看列表
  submitDayPlan: (params) => {
    return post("/plan/lng/submitDayPlan", params);
  }, //LNG-新增保存日计划
  editDayPlan: (params) => {
    return post("/plan/lng/editDayPlan", params);
  }, //LNG-编辑保存日计划
  saveDayPlan: (params) => {
    return post("/plan/lng/saveDayPlan", params);
  }, //LNG-新增提报日计划
  editSubmitDayPlan: (params) => {
    return post("/plan/lng/editSubmitDayPlan", params);
  }, //LNG-编辑提报日计划
  changeDayPlan: (params) => {
    return post("/plan/lng/changeDayPlan", params);
  }, //LNG-变更日计划
  getDayAverager: (params) => {
    return post("/plan/lng/getDayAverager", params);
  }, //获取日均需求量
  queryConstomerBalance: (params) => {
    return post("/plan/lng/queryConstomerBalance", params);
  }, //提报-余额校验
};

export default lngApi;
